import * as Bag from './components/Bag.css';

export default {
	Bag
};
